import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {colours} from './answers'

export const Colours = () => {
  const {submitAnswers} = useOutletContext()
  return (
    <div className="column">
      <section className="question">
        <div className="content size-xl">I'll be wearing...</div>
      </section>
      <section className="answers double">
        <div className="content">
          {colours.map(it => (
            <Button
              size="large"
              action={() => submitAnswers([it.swatch?.alt ?? it.label])}
              key={it.swatch?.alt ?? it.label}
            >
              {it.label}
              <div className="float-cover">
                {it.swatch.img
                  ? <img className="button-icon swatch" src={it.swatch.img} alt={`${it.swatch.alt} swatch`} />
                  : <span className="button-icon swatch" style={{
                      backgroundColor: it.swatch.colour,
                    }} />
                }
              </div>
            </Button>
          ))}
        </div>
      </section>
    </div>
  )
}
